import React, { useState, useEffect } from "react";
import { Col, Row, Form, FormFeedback, Label, Input } from "reactstrap";
import { userInputData } from "../../../Utils/user-profile-data";
import MyProfile from "../../../../images/new-images/my-profile.png";
import editIcon from "../../../../images/new-images/profile-edit.png";
import profileCategory from "../../../../images/profile-category.png";
import "./EditProfile.css";

const EditProfile = (props) => {


  const [gender, setGender] = useState()



  if (props.profileData !== "") {
    if (props.profileData) {

    }
  }

  useEffect(() => {
    props.profileData.map(d => setGender(d.gender))
  }, [props.profileData])

  return (
    <div className="edit-profile">
      <Form onSubmit={props.handleFieldValidation}>
        <Row>
          <img className="header-img" src={MyProfile} />
          <p className="heading">My Profile</p>
          <img
            hidden={props.showEditIcon}
            onClick={props.handleEnableField}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                props.handleEnableField(e);
              }
            }}
            className="edit-icon"
            src={editIcon}
            alt="Edit profile"
            tabIndex={0}
            role="button"
            aria-label="Edit profile"
          />
          <Col className="profile-buttons">
            <input
              hidden={props.hidButton}
              type="reset"
              className="reset"
              value="RESET"
            />
            <input
              type="submit"
              value="SUBMIT"
              hidden={props.hidButton}
              className="submit"
            />
          </Col>
        </Row>
        {props.profileData.map((details, index) => {
          return (
            <React.Fragment key={index}>
              <div className="section-header">
                <img className="header-img" src={profileCategory} />
                <h1 className="section-heading"> Basic Information </h1>
              </div>
              <div className="section">
                <Row>
                  {props.profileFormData.map((profileData, index) => {
                    return (
                      <Col md={6} key={index}>
                        {profileData.formLabel === "First Name" ||
                          profileData.formLabel === "Last Name" ||
                          profileData.formLabel === "Short Name" ||
                          profileData.formLabel === "Gender" ||
                          profileData.formLabel === "Marital Status" ? (
                          <React.Fragment>
                            <Label>{profileData.formLabel}</Label>
                            <span
                              hidden={props.hidButton}
                              className="required-field"
                            ></span>
                          </React.Fragment>
                        ) : (
                          <Label>{profileData.formLabel}</Label>
                        )}
                        {profileData.inputType === "select" ? (
                          profileData.formLabel === "Gender" ? (
                            <React.Fragment>
                              <Input
                                disabled={props.disableField}
                                invalid={props.fieldValidation}
                                type={profileData.inputType}
                                name={profileData.name}
                                id={profileData.inputId}
                                onChange={(e) => {
                                  props.basicInfoSelect(e.target.value, index)
                                  setGender(e.target.value)
                                }}
                                value={gender}
                              >
                                <option disabled>Select</option>
                                {profileData.gender_dropdownOptions.map(
                                  (getGenderDropdownOptions, index) => {
                                    return (
                                      <option
                                        value={getGenderDropdownOptions.gender_Id}
                                        key={index}
                                      >
                                        {getGenderDropdownOptions.options}
                                      </option>
                                    );
                                  }
                                )}
                              </Input>
                              <FormFeedback>
                                please select {profileData.formLabel}
                              </FormFeedback>
                            </React.Fragment>
                          ) : profileData.formLabel === "Marital Status" ? (
                            <React.Fragment>


                              <Input
                                disabled={props.disableField}
                                invalid={props.maritalStatusFieldValidation}
                                type={profileData.inputType}
                                name={profileData.name}
                                id={profileData.inputId}
                                onChange={(e) => {
                                  const selectedOption = profileData.dropdownOptions.find(
                                    option => option.status_Id.toString() === e.target.value
                                  );
                                  props.basicInfoSelect({
                                    value: selectedOption ? selectedOption.status_Id : '',
                                    text: selectedOption ? selectedOption.options : ''
                                  }, index);
                                }}
                                value={props.maritalStatusId || ''}
                              >
                                <option value="">Select</option>
                                {profileData.dropdownOptions.map(
                                  (getDropdownOptions, index) => {
                                    return (
                                      <option
                                        value={getDropdownOptions.status_Id}
                                        key={index}
                                      >
                                        {getDropdownOptions.options}
                                      </option>
                                    );
                                  }
                                )}
                              </Input>
                              {props.maritalStatusFieldValidation && (
                                <FormFeedback>Marital Status cannot be empty</FormFeedback>
                              )}
                            </React.Fragment>

                          ) : (
                            <Input
                              disabled={props.disableField}
                              type={profileData.inputType}
                              name={profileData.name}
                              id={profileData.inputId}
                              onChange={(e) =>
                                props.basicInfoSelect(e.target.value, index)
                              }
                              value={details.country}
                              defaultValue={userInputData(details, profileData)}
                            >
                              <option disabled>Select</option>
                              {profileData.formLabel === "Country"
                                ? props.CountryData.map((option, index) => {
                                  return (
                                    <option key={index} value={option.id}>
                                      {option.country_name}
                                    </option>
                                  );
                                })
                                : profileData.dropdownOptions.map(
                                  (getDropdownOptions, index) => {
                                    return (
                                      <option
                                        value={getDropdownOptions.status_Id}
                                        key={index}
                                      >
                                        {getDropdownOptions.options}
                                      </option>
                                    );
                                  }
                                )}
                            </Input>
                          )
                        ) : profileData.formLabel === "First Name" ||
                          profileData.formLabel === "Last Name" ||
                          profileData.formLabel === "Short Name" ? (
                          <div>
                            <Input
                              disabled={props.disableField}
                              invalid={
                                profileData.formLabel === "First Name" ?
                                  props.firstNameFieldValidation :
                                  profileData.formLabel === "Last Name" ?
                                    props.lastNameFieldValidation :
                                    profileData.formLabel === "Short Name" ?
                                      props.shortNameFieldValidation :
                                      props.fieldValidation
                              }
                              type={profileData.inputType}
                              name={profileData.name}
                              placeholder={profileData.placeHolder}
                              id={profileData.inputId}
                              defaultValue={userInputData(details, profileData)}
                              onChange={(e) =>
                                props.handleFormInput(e.target.value, index)
                              }
                            />
                            <FormFeedback>
                              {" "}
                              {profileData.formLabel} cannot be empty
                            </FormFeedback>
                          </div>
                        ) : profileData.formLabel === "Email Address" ? (
                          <Input
                            readOnly
                            type={profileData.inputType}
                            name={profileData.name}
                            placeholder={profileData.placeHolder}
                            id={profileData.inputId}
                            defaultValue={userInputData(details, profileData)}
                          />
                        ) : (
                          <Input
                            disabled={props.disableField}
                            type={profileData.inputType}
                            name={profileData.name}
                            placeholder={profileData.placeHolder}
                            id={profileData.inputId}
                            defaultValue={userInputData(details, profileData)}
                            onChange={(e) =>
                              props.basicInfoSelect(e.target.value, index)
                            }
                          />
                        )}
                      </Col>
                    );
                  })}
                </Row>
              </div>
              <div className="section-header">
                <img className="header-img" src={profileCategory} />
                <h1 className="section-heading"> Professional Information </h1>
              </div>
              <div className="section">
                <Row>
                  {props.personalInfoData.map((getPersonalData, index) => {
                    return (
                      <Col md={6} key={index}>
                        <Label>{getPersonalData.formLabel}</Label>
                        {getPersonalData.inputType === "select" ? (
                          <Input
                            disabled={props.disableField}
                            type={getPersonalData.inputType}
                            name={getPersonalData.name}
                            id={getPersonalData.inputId}
                            onChange={(e) =>
                              props.professionalSelect(e.target.value, index)
                            }
                            defaultValue={userInputData(
                              details,
                              getPersonalData
                            )}
                          >
                            <option disabled>Select</option>
                            {getPersonalData.formLabel === "Qualification"
                              ? props.qualificationdropDownData.demographics &&
                              props.qualificationdropDownData.demographics.map(
                                (getPersonalInfoDropdown, index) => {
                                  return (
                                    <option
                                      value={getPersonalInfoDropdown.id}
                                      key={index}
                                    >
                                      {
                                        getPersonalInfoDropdown.demographic_name
                                      }
                                    </option>
                                  );
                                }
                              )
                              : props.industrydropDownData.demographics &&
                              props.industrydropDownData.demographics.map(
                                (getInfo, index) => {
                                  return (
                                    <option value={getInfo.id} key={index}>
                                      {getInfo.demographic_name}
                                    </option>
                                  );
                                }
                              )}
                          </Input>
                        ) : (
                          <Input
                            disabled={props.disableField}
                            type={getPersonalData.inputType}
                            placeholder={getPersonalData.placeHolder}
                            name={getPersonalData.name}
                            id={getPersonalData.inputId}
                            onChange={(e) =>
                              props.professionalSelect(e.target.value, index)
                            }
                            defaultValue={userInputData(
                              details,
                              getPersonalData
                            )}
                          />
                        )}
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </React.Fragment>
          );
        })}
      </Form>
    </div>
  );
};

export default EditProfile;



// WEBPACK FOOTER //
// ./src/new/Components/View-Or-Edit-profile/EditProfile/EditProfile.jsx